import { CSSProperties } from 'react';

export interface ProgressBarProps {
  /** 0..1 fill ratio */
  value: number;
  mini?: boolean;
  tone?: 'accent' | 'success' | 'warning' | 'danger';
  className?: string;
  style?: CSSProperties;
}

const TONE_VARS: Record<NonNullable<ProgressBarProps['tone']>, string> = {
  accent: 'var(--accent-500)',
  success: 'var(--success-500)',
  warning: 'var(--warning-500)',
  danger: 'var(--danger-500)',
};

export function ProgressBar({
  value,
  mini = false,
  tone = 'accent',
  className = '',
  style,
}: ProgressBarProps) {
  const pct = Math.max(0, Math.min(1, value || 0)) * 100;
  return (
    <div
      className={`ds-prog ${mini ? 'ds-prog-mini' : ''} ${className}`.trim()}
      style={style}
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <i style={{ width: `${pct}%`, background: TONE_VARS[tone] }} />
    </div>
  );
}

export default ProgressBar;
